/** Gentle gray with a touch of blue. Shared by the board and factory run list. */
export const WORK_ORDER_CARD_HOVER_SURFACE_CLASS = "hover:bg-slate-100 dark:hover:bg-slate-800/55";
